import { cva } from 'class-variance-authority';

export const labelClasses = cva('flex cursor-pointer items-center gap-4', {
  variants: {
    disabled: {
      true: 'cursor-not-allowed opacity-50'
    }
  }
});

export const hiddenInputClasses = cva('absolute h-0 w-0 opacity-0');

export const customRadioClasses = cva(
  'p-0-5 flex min-h-[18px] min-w-[18px] items-center justify-center rounded-full border-1 border-solid transition-all duration-200',
  {
    variants: {
      checked: {
        true: 'border-charcoal-500',
        false: 'border-pebble-500 bg-white-50'
      }
    }
  }
);

export const radioDotClasses = cva('rounded-full transition-all duration-200', {
  variants: {
    checked: {
      true: 'bg-charcoal-500 h-2 w-2 opacity-100',
      false: 'h-2 w-2 bg-transparent opacity-0'
    }
  }
});
